/**
 * File: useZohoChecksQueries.ts
 * Path: apps/admin/src/features/accounting/hooks/useZohoChecksQueries.ts
 * Description: The saved month-end Compare with Zoho results. Kept under the
 * books' own query key, so any change to the books refreshes them too.
 */

import { useQuery } from "@tanstack/react-query";
import { booksKey } from "@/shared/hooks/useBooksQueries";
import { zohoChecksRepo } from "../services/zohoChecksService";

export const useZohoChecks = (profileId: string, enabled = true) =>
  useQuery({
    queryKey: [...booksKey(profileId), "zohoChecks"],
    queryFn: () => zohoChecksRepo.list(profileId),
    enabled,
  });
